import React from "react";
import { Icon } from "@iconify/react";

type DropdownArrowIconProps = {
  isOpen: boolean;
  height?: number;
  icon?: string;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
};

const DropdownArrowIcon = ({
  isOpen,
  height = 12,
  icon = "ion:chevron-down",
  color,
  style,
  className,
  onClick,
}: DropdownArrowIconProps) => (
  <Icon
    icon={icon}
    height={height}
    className={className}
    style={{
      color,
      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.15s ease",
      ...style,
    }}
    onClick={onClick}
  />
);

export default DropdownArrowIcon;
